// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2usfR","file":"styles_file__1Sgx6"};